<template>
	<div class='repair-country-wrap flex'>
		<div class="country-left">
			<div class="country-left-title">
				全部
			</div>
			<ul class="country-left-ul">
				<li class="">
					<a class="active" href="javascript:void(0)"><i class="iconfont icon-file-text-o"></i>流程指引</a>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/xfzn/" target="_blank"><i class="iconfont icon-file-text-o"></i>修复指南</a>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/xcslwd/" target="_blank"><i class="iconfont icon-search"></i>现场受理网点</a>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/gyxxy/" target="_blank"><i class="iconfont icon-file-text-o"></i>公益性信用修复培训及报告</a>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/pxpt/" target="_blank"><i class="iconfont icon-file-text-o"></i>“信用中国”网站公益性在线培训平台</a>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/xfpxjgmd/" target="_blank"><i class="iconfont icon-search"></i>信用修复培训机构名单</a>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/xygbfwjgmd/" target="_blank"><i class="iconfont icon-search"></i>信用报告服务机构名单</a>
				</li>
				<li class="">
					<a href="https://public.creditchina.gov.cn/htmls/repair/repairSearch.html" target="_blank"><i class="iconfont icon-search"></i>修复进度自助查询</a>
				</li>
				<li class="">
					<a href="https://www.creditchina.gov.cn/xyxf/cjwd/" target="_blank"><i class="iconfont icon-file-text-o"></i>常见问答</a>
				</li>
			</ul>
		</div>

		<div class="country-right">
			<div class="country-title">
				<img src="@/static/images/repair/3.png">流程指引
			</div>
			<div class="country-right-image">
				<img src="@/static/images/repair/xyxf1.jpg" alt="">
			</div>
			<div class="country-title">
				<img src="@/static/images/repair/3.png">材料清单及说明
			</div>
			<process routeName="country" />
		</div>
	</div>
</template>

<script>
import process from '@/components/process';
export default {
	components: {
		process
	},
	data() {
		return {}
	},
	created() { },
	mounted() { },
	methods: {},
	computed: {},
	watch: {},
}
</script>
<style lang='scss' scoped>
	.repair-country-wrap {
		width: 100%;
		align-items: flex-start;

		.country-left {
			width: 180px;
			flex-shrink: 0;
			font-size: 14px;
			padding: 0;
			margin-top: 46px;
			.country-left-title {
				font-size: 20px;
				font-weight: normal;
				border-bottom: 1px solid #dddddd;
				padding-bottom: 12px;
			}
			.country-left-ul {
				li {
					list-style: none;
					padding: 17px 0 17px 25px;
					border-bottom: 1px solid #dddddd;
					cursor: pointer;
					a {
						letter-spacing: 1px;
						color: #333;
						&.active {
							color: #e22323;
						}
						i.iconfont {
							font-size: 14px;
							display: inline-block;
							margin-right: 8px;
						}
					}
				}
			}
		}
		.country-right {
			width: calc(100% - 180px);
			padding-left: 36px;
			box-sizing: border-box;
			overflow: hidden;
			margin-top: 22px;

			.country-right-image {
				padding: 10px 0 0;
				img {
					width: 100%;
				}
			}

			.country-title {
				font-size: 15px;
				line-height: 53px;
				color: #333;
				img {
					vertical-align: middle;
					width: 8px;
					margin-right: 10px;
				}
			}
		}
	}
</style>